<div class="container-responsive">
  <!-- Panel principal del árbol -->
  <mat-card appearance="outlined" [class.panel-reduced]="showDetails">
    <mat-card-header>
      <div class="header-nombre-nuevo">
        <h2>Administración - Menús Desplegables</h2>
        <p class="subtitle">Gestión de casos de uso con vista de árbol y detalles</p>
      </div>
    </mat-card-header>

    <mat-card-content>
      <ngx-spinner [zIndex]="100" name="spListado" bdColor="rgba(255,255,255,0.8)"
        size="default" color="var(--primary-color)" type="ball-atom" [fullScreen]="false">
      </ngx-spinner>

      <mat-form-field appearance="outline" class="filter-input">
        <mat-label>Filtrar árbol</mat-label>
        <input matInput [(ngModel)]="filterText" (input)="filterTree()">
        <button *ngIf="filterText" matSuffix mat-icon-button aria-label="Clear"
          (click)="filterText=''; filterTree()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="custom-tree">
        <!-- Nodo hoja con botón de detalles -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
          <button mat-icon-button disabled></button>
          <mat-icon class="tree-icon">{{node.icon}}</mat-icon>
          <span class="tree-node-content">
            <a class="tree-link" [routerLink]="getFullUrl(node)">{{ node.name }}</a>

            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">

              <button mat-menu-item (click)="showNodeDetails(node)"
              *ngIf="node.casoUso">
                <mat-icon>visibility</mat-icon>
                <span>Ver</span>
              </button>
              <button mat-menu-item (click)="onNodeClick(node)">
                <mat-icon>edit</mat-icon>
                <span>Gestionar</span>
              </button>
            </mat-menu>
          </span>
        </mat-tree-node>

        <!-- Nodo con hijos -->
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
          <div class="mat-tree-node" matTreeNodePadding>
            <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
              <mat-icon class="mat-icon-rotate" [class.expanded]="treeControl.isExpanded(node)">
                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
              </mat-icon>
            </button>
            <mat-icon class="tree-icon">{{node.icon}}</mat-icon>
            <span>{{ node.name }}</span>
          </div>
          <div *ngIf="treeControl.isExpanded(node)">
            <ng-container matTreeNodeOutlet></ng-container>
          </div>
        </mat-nested-tree-node>
      </mat-tree>
    </mat-card-content>
  </mat-card>

  <!-- Panel de detalles -->
  <mat-card appearance="outlined" class="details-panel" *ngIf="showDetails && selectedNode">
    <mat-card-header>
      <div class="details-header">
        <h3>Detalles del Caso de Uso</h3>
        <button mat-icon-button (click)="closeDetails()" matTooltip="Cerrar detalles">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </mat-card-header>

    <mat-card-content *ngIf="selectedNode.casoUso">
      <div class="detail-section">
        <h4><mat-icon>info</mat-icon> Información General</h4>
        <div class="detail-grid">
          <div class="detail-item">
            <strong>Nombre:</strong>
            <span>{{ selectedNode.casoUso.nombre || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <strong>Descripción:</strong>
            <span>{{ selectedNode.casoUso.descripcion }}</span>
          </div>
          <div class="detail-item">
            <strong>Icono:</strong>
            <span><mat-icon>{{ selectedNode.casoUso.icon }}</mat-icon> {{ selectedNode.casoUso.icon }}</span>
          </div>
        </div>
      </div>

      <div class="detail-section">
        <h4><mat-icon>link</mat-icon> Navegación</h4>
        <div class="detail-grid">
          <div class="detail-item">
            <strong>Ruta:</strong>
            <span class="code-text">{{ selectedNode.casoUso.path || 'Sin ruta' }}</span>
          </div>
          <div class="detail-item">
            <strong>Orden:</strong>
            <span>{{ selectedNode.casoUso.orden }}</span>
          </div>
        </div>
      </div>

      <div class="detail-section">
        <h4><mat-icon>settings</mat-icon> Estados</h4>
        <div class="chips-container">
          <mat-chip-set>
            <mat-chip [class.chip-active]="selectedNode.casoUso.visible"
              [class.chip-inactive]="!selectedNode.casoUso.visible">
              <mat-icon>{{ selectedNode.casoUso.visible ? 'visibility' : 'visibility_off' }}</mat-icon>
              {{ selectedNode.casoUso.visible ? 'Visible' : 'Oculto' }}
            </mat-chip>
            <mat-chip [class.chip-active]="selectedNode.casoUso.habilitado"
              [class.chip-inactive]="!selectedNode.casoUso.habilitado">
              <mat-icon>{{ selectedNode.casoUso.habilitado ? 'check_circle' : 'cancel' }}</mat-icon>
              {{ selectedNode.casoUso.habilitado ? 'Habilitado' : 'Deshabilitado' }}
            </mat-chip>
            <mat-chip [class.chip-active]="selectedNode.casoUso.esMenuDesplegable"
              [class.chip-inactive]="!selectedNode.casoUso.esMenuDesplegable">
              <mat-icon>{{ selectedNode.casoUso.esMenuDesplegable ? 'menu' : 'menu_open' }}</mat-icon>
              {{ selectedNode.casoUso.esMenuDesplegable ? 'Menú Desplegable' : 'No es Menú' }}
            </mat-chip>
          </mat-chip-set>
        </div>
      </div>

      <div class="detail-section" *ngIf="selectedNode.casoUso.menu">
        <h4><mat-icon>folder</mat-icon> Menú Padre</h4>
        <div class="detail-grid">
          <div class="detail-item">
            <strong>ID Menú:</strong>
            <span>{{ selectedNode.casoUso.menu.id }}</span>
          </div>
          <div class="detail-item">
            <strong>Descripción:</strong>
            <span>{{ selectedNode.casoUso.menu.descripcion }}</span>
          </div>
          <div class="detail-item" *ngIf="selectedNode.casoUso.menu.icon">
            <strong>Icono del Menú:</strong>
            <span><mat-icon>{{ selectedNode.casoUso.menu.icon }}</mat-icon> {{ selectedNode.casoUso.menu.icon }}</span>
          </div>
        </div>
      </div>

      <!-- Información de auditoría si está disponible -->
      <div class="detail-section" *ngIf="selectedNode.casoUso.fechaCreacion || selectedNode.casoUso.fechaModificacion">
        <h4><mat-icon>history</mat-icon> Auditoría</h4>
        <div class="detail-grid">
          <div class="detail-item" *ngIf="selectedNode.casoUso.fechaCreacion">
            <strong>Fecha Creación:</strong>
            <span>{{ selectedNode.casoUso.fechaCreacion | date:'dd/MM/yyyy HH:mm' }}</span>
          </div>
          <div class="detail-item" *ngIf="selectedNode.casoUso.fechaModificacion">
            <strong>Última Modificación:</strong>
            <span>{{ selectedNode.casoUso.fechaModificacion | date:'dd/MM/yyyy HH:mm' }}</span>
          </div>
        </div>
      </div>

    </mat-card-content>
  </mat-card>
</div>
